"use client"

import { Music2 } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `Music2Icon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const Music2Icon = component(Icon)({ as: Music2 })
